<template >
  <div v-if="lesson">

    <div class="row">
      <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h4>{{lesson.name}}</h4>
          </div>
          <div class="card-body">
            <h4 class="mb-1">Үнэ:
              <span class='badge badge-success' v-if="lesson.price==null || lesson.price==undefined || lesson.price==0">Free</span>
              <span class='badge badge-info' v-else>{{lesson.price}}</span>
            </h4>
            <p>{{lesson.description}}</p>
            <div class="btn btn-info btn-sm">
              <router-link :to="{ name: 'LessonEdit', params: { lessonId: lesson.id}}" class="text-white">Хичээлийн мэдээлэл засах</router-link>
            </div>
            <div class="btn btn-default  btn-sm mx-1 my-2">
              <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'lessons/'+lesson.id}}">Хичээлийн зураг оруулах</router-link>
            </div>
            <br/>
            

            <br/>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <button class="btn btn-outline-secondary btn-sm" type="button" v-for="type in lesson.types">
                  {{type}}

                </button>

              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h4>Мэдээлэл</h4>
          </div>
          <div class="card-body">
            <p style="margin-bottom: 0rem;">Багш:<span style="font-weight:bold">{{lesson.profession}}</span></p>
            <p style="margin-bottom: 0rem;">Xичээлийн код: <span style="font-weight:bold">{{lesson.lectureCode}}, {{lesson.id}}</span></p>
            
            <p style="margin-bottom: 0rem;" v-if="lesson.semester">Улирал: <span style="font-weight:bold">{{lesson.semester.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.credit">Кредит: <span style="font-weight:bold">{{lesson.credit}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.school">Сургууль: <span style="font-weight:bold">{{lesson.school.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.department">Xөтөлбөрийн баг: <span style="font-weight:bold">{{lesson.department.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.program">Хөтөлбөр: <span style="font-weight:bold">{{lesson.program.id}}</span></p>
          </div>
        </div>
      </div>


    </div>

  
    </div>
    
</template>

<script>
const fb = require('../../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode'

export default {
    name: "ILessonHeader",

    data() {
        return {
            lesson: null,
            display:0,
            size:100
            
        };
    },
    components: {
      VueQrcode,
    },
    methods: {



      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },

      setPublished(value, lesson){
        this.setProperty("published", fb.db.doc("lessons/"+lesson.id), value);
        if(value==true){
          if(lesson.school!=null && lesson.school!=undefined)
            lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
          if(lesson.department!=null && lesson.department!=undefined)
            lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
          if(lesson.program!=null && lesson.program!=undefined)
            lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});

          var publish = firebase.functions().httpsCallable('publishLesson');
          publish(
            { lessonId: lesson.id}
          );
        }
        else{
          if(lesson.school!=null && lesson.school!=undefined)
            lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          if(lesson.department!=null && lesson.department!=undefined)
            lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          if(lesson.program!=null && lesson.program!=undefined)
            lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          var unpublish = firebase.functions().httpsCallable('unPublishLesson');
          unpublish(
            { lessonId: lesson.id}
          );
        }
      }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lesson: { 
            required: true,
        }
    },
    created() {
 
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

